import { ContactPage } from '@/components/pages/Contact'

export default ContactPage
